import React from 'react';
import { facts } from '../data/content';
export function FactStrip() {
  return <section aria-label="What the toolkit includes" className="w-full border-b border-charcoal/10 bg-white px-5 md:px-8" data-id="element-58" data-mp="2lajtwxufqgqx">
      <ul className="mx-auto grid w-full max-w-content grid-cols-2 md:grid-cols-4" data-id="element-59" data-mp="2gafmdxbi8wcu">
        {facts.map((fact, index) => <li key={fact} className={`flex flex-col items-center justify-center px-3 py-8 text-center md:py-10 ${index % 2 === 1 ? 'border-l border-charcoal/10' : ''} ${index > 1 ? 'border-t border-charcoal/10 md:border-t-0' : ''} ${index === 2 ? 'md:border-l' : ''}`} data-id="element-60" data-mp="2c92fdjwoen4c" data-mpi={index}>
            <span aria-hidden="true" className="mb-3 h-px w-8 bg-brass" data-id="element-61" data-mp="1sm4qz9okvovy" />
            <span className="font-serif text-xl font-semibold leading-tight text-charcoal md:text-2xl" data-id="element-62" data-mp="1sjs3kh01wmbi">
              {fact}
            </span>
          </li>)}
      </ul>
    </section>;
}